module.exports = __webpack_public_path__ + "static/e2470b2bc782f739d858232eadb600675262f6ad27c5db37376aedb133d266fa-a94b7e3b970a29de399a2d38ff3a2027.jpeg";